import { Link } from '@/i18n/navigation'
import styles from './SubmenuItem.module.css'
import { ComponentType, SVGProps, useMemo } from 'react'
import { pushToDataLayer, removeLocaleFromPath } from '@/utils/helpers'
import { useUserStore } from '@/stores/useUserStore'
import { usePathname } from 'next/navigation'
import SubmenuLabel, { SubmenuLabelKind } from '../Label/SubmenuLabel'

interface SubmenuItemProps {
  href?: string
  content?: string
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  selected?: boolean
  className?: string
  testId?: string
  target?: string
  isNew?: boolean
  onClick?: React.MouseEventHandler<HTMLElement>
}

export default function SubmenuItem ({ href, className, content, icon: SubmenuItemIcon, selected, target, isNew, testId, onClick }: SubmenuItemProps) {
  const classes = `${styles.container} ${selected ? styles.selected : ''} ${className ?? ''}`
  const { userId, profileId } = useUserStore()
  const rawPath = usePathname()
  const pathname = useMemo (
    () => removeLocaleFromPath(rawPath),
    [rawPath]
  )

  function handleClick(e: React.MouseEvent<HTMLElement>) {
    pushToDataLayer({
      event: "submenu_item_click",
      page_name: pathname,
      user_state: userId && profileId ? 'loggedIn' : 'loggedOut',
      menu_item: content
    })
    if (onClick) onClick(e)
  }


  if (href) {
    return (
      <Link href={href} className={classes} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={handleClick} data-testid={testId}>
        {SubmenuItemIcon !== undefined && <SubmenuItemIcon className={styles.icon} />}
        {content && <p className={'bodyTextLarge'}>{content}</p>}
        {isNew && <SubmenuLabel kind={SubmenuLabelKind.NEW} />}
      </Link>
    )
  }

  return (
    <button className={classes} onClick={handleClick} data-testid={testId}>
      {SubmenuItemIcon !== undefined && <SubmenuItemIcon className={styles.icon} />}
      {content && <p className={'bodyTextLarge'}>{content}</p>}
      {isNew && <SubmenuLabel kind={SubmenuLabelKind.NEW} />}
    </button>
  )
}